import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EPCSQueue {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  EPCSQueueData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: EPCSQueue = {
  isLoading: false,
  error: false,
  message: null,
  EPCSQueueData: [],
  Items: [],
  Pagination: [],
};

const EPCSQueueSlice = createSlice({
  name: "epcsqueue",
  initialState,
  reducers: {
    loadingEpcsQueue: (state: EPCSQueue, action: PayloadAction<{}>) => {
      state.isLoading = true;
    },
    setEpcsQueue: (state: any, action: PayloadAction<EPCSQueue>) => {
      return action.payload;
    },
    clearData: (state: EPCSQueue, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingEpcsQueue, setEpcsQueue, clearData } =
  EPCSQueueSlice.actions;

export default EPCSQueueSlice.reducer;
